module.exports = __webpack_public_path__ + "img/landingpage-bg5.d4ca0016.png";